import { PropsWithChildren, useContext } from "react";
import { Button, ToolbarButton, ToolbarDivider, ToolbarGroup, makeStyles, shorthands, tokens } from "@fluentui/react-components";
import {
    AddRegular
} from "@fluentui/react-icons";
import Grid from '@mui/material/Unstable_Grid2';
import { useL10n } from "context/l10n-context";
import { ILocaleStrings } from "loc/locale.interfaces";
import ScrollPanel from "components/layout/scroll-panel/scroll-panel";
import LoadingErrorBar from "components/common/loading-error-bar/loading-error-bar";
import LoadingSpinner from "components/common/loading-spinner/loading-spinner";
import { IApplicationRolesTilesProps } from "./application-roles-tiles.props";
import ApplicationRoleTile from "./application-roles-tile";
import Trimmed from "components/common/trimmed/trimmed";
import { PPAPermissions } from "lib/permissions";

const layoutStyles = makeStyles({
    buttonsWrapper: {
        //...shorthands.borderWidth('1px', '0'),
        ...shorthands.margin('1em', '1.5em')
    },
    tilesWrapper: {
        //...shorthands.borderWidth('1px', '0'),
        ...shorthands.margin('0.2em', '1.5em', '1em', '1.5em')
    }
});

export default function ApplicationRolesTiles(props: IApplicationRolesTilesProps) {
    const styles = layoutStyles();
    const { t } = useL10n<ILocaleStrings>();

    return (
        <ScrollPanel
            fixed={
                <div className={styles.buttonsWrapper}>
                    <Trimmed permission={PPAPermissions.AddApplicationRole}>
                        <Button
                            icon={<AddRegular />}
                            appearance="outline"
                            onClick={() => props.onAddApplicationRoleClick()}>{t('add')}</Button>
                    </Trimmed>
                </div>
            }
            scroll={
                <div className={styles.tilesWrapper}>
                    <LoadingSpinner loading={props.loading} />
                    <LoadingErrorBar error={props.apiError} />
                    <Grid container spacing={2}>
                        {props.applicationRoles.map((role: any, idx) => (
                            <Grid key={idx} xs={12} sm={6} lg={4} >
                                <ApplicationRoleTile
                                    key={role.id}
                                    applicationRole={role}
                                    onAddApplicationRoleClick={props.onAddApplicationRoleClick}
                                    onEditApplicationRoleClick={props.onEditApplicationRoleClick}
                                    onEditApplicationRolePermissionLevelClick={props.onEditApplicationRolePermissionLevelClick}
                                    onDeleteApplicationRoleClick={props.onDeleteApplicationRoleClick}
                                    onEditApplicationRoleMembershipClick={props.onEditApplicationRoleMembershipClick} />
                            </Grid>
                        ))}
                    </Grid>
                </div>
            }
        />
    );
}